import {TextButtonProps} from '../Button';
import {HyperlinkProps} from '../HyperLink/HyperLink';
import {IconButtonProps} from '../Button';
import React from 'react';
import {IconDropdownButtonProps} from "../Dropdown/DropdownButtonTypes";
import {ToggleButtonProps} from "../Toggles/ToggleButton";

export interface ModalHeaderIconButton extends Omit<IconButtonProps, 'hideOnLowWidth' | 'flatEdge' | 'isInMobileMenu' | 'useTransparentBackground' | 'shouldNotInteract' | 'unsetIconSize' | 'borderRadius' | 'focusBackgroundColor' | 'children' | 'focusOnClick'> {
  componentType: 'icon';
  icon: React.ReactNode;
}

export interface ModalHeaderDropdownButton extends Omit<IconDropdownButtonProps, 'size' | 'type'> {
  componentType: 'dropdown';
}

export interface ModalHeaderToggleButton extends ToggleButtonProps {
  componentType: 'toggle';
}

export type ModalHeaderButtons = ModalHeaderIconButton | ModalHeaderDropdownButton | ModalHeaderToggleButton;


export interface ButtonAction extends Pick<TextButtonProps, 'variant' | 'id' | 'loading' | 'disabled' | 'icon' | 'type'> {
  action?: (() => void) | ((e: any) => void);
  text?: string;
  children?: React.ReactNode;
}

export interface LeftFooterActionBase {
  actionType: 'hyperlink' | 'note' | 'button';
  text: string;
  icon?: React.ReactNode;
  action?: (() => void) | ((e: any) => void);
}

export interface LeftFooterHyperlink extends HyperlinkProps, LeftFooterActionBase {
}

export interface LeftFooterButton extends Pick<TextButtonProps, 'variant' | 'id' | 'loading' | 'disabled' | 'icon' | 'type'>, LeftFooterActionBase {
  children?: React.ReactNode;
}

export type LeftFooterAction = LeftFooterButton | LeftFooterHyperlink;
